<template>
  <div>
    <div class="vm-search">
      <vm-search label="物料号">
        <el-input v-model="materialNos" type="textarea" autosize placeholder="支持输入多行"/>
      </vm-search>
      <vm-search label="物料描述/规格型号">
        <el-input v-model="materialName" placeholder="请输入"/>
      </vm-search>
      <vm-search :value-width="150" style="margin-left: 6px" label="">
        <el-button :loading="contentLoading" type="primary" style="padding: 6px 8px" @click="handleSearchClick">
          查询
        </el-button>
        <el-button
            v-if="exportAuth"
            :loading="exportLoading"
            type="success"
            style="padding: 6px 8px"
            @click="handleExport">
          导出
        </el-button>
      </vm-search>
    </div>
    <div>
      <el-table
          ref="elTable"
          :data="tableData"
          border
          :row-style="rowStyle"
          style="margin-top: 8px"
          height="calc(100vh - 130px)"
          :span-method="spanMethod">
        <el-table-column prop="matnr" label="物料号" align="center" width="150"/>
        <el-table-column prop="mappingMaterialNo" label="老物料号" align="center" width="150"/>
        <el-table-column prop="zmyxh" label="型号" align="center" width="150"/>
        <el-table-column prop="locationNo" label="小仓位" align="center" width="150"/>
        <el-table-column prop="manufacturerModel" label="厂家型号" align="center" width="150"/>
        <el-table-column prop="specialFlag" label="特殊库存标识" align="center" width="150"/>
        <el-table-column prop="maktx" label="物料描述" align="center"/>
        <el-table-column prop="matkl" label="物料组" align="center" width="90"/>
        <el-table-column prop="lgort" label="存储地点11" align="center" width="150">
          <template slot-scope="scope">
            <el-select v-model="scope.row.lgort" disabled placeholder="请选择">
              <el-option
                  v-for="item in constants.locationNo.$options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="meins" label="单位" align="center" width="80"/>
        <el-table-column prop="labst" label="库存" align="center" width="120"/>
        <el-table-column prop="mtart" label="物料类型" align="center" width="90"/>
        <el-table-column prop="vbeln" label="销售订单编号" align="center" width="150"/>
        <el-table-column prop="posnr" label="销售订单行号" align="center" width="120"/>
      </el-table>
    </div>
  </div>
</template>

<script>
  import VmSearch from "@/components/VmSearch.vue";
  import constants from "@/util/constants";
  export default {
    name: "SapMaterialWarehousing",
    components: {VmSearch},
    data() {
      return {
        constants,
        contentLoading: false,
        exportLoading: false,
        materialNos: "",
        materialName: "",
        exportAuth: this.$auth(553),
        tableData: [],
      };
    },
    methods: {
      handleSearchClick() {
        let list = this.materialNos.split("\n").map(line => line.trim()).filter(item => item.length > 0);
        if (list.length === 0 && this.materialName.trim().length==0) {
          this.$message.error("请输入物料号或物料描述");
          return;
        }
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("materialName", this.materialName);
        formData.append("materialNos", list);
        this.contentLoading = true;
        this.$http.post("basic", "sapBaseMaterials/stock",formData)
          .then(res => {
            if (res.success) {
              this.tableData = res.data;
            }
          })
          .catch(() => {
            this.tableData = [];
          })
          .finally(() => {
            this.contentLoading = false;
          });
      },
      rowStyle({row}) {
        return row.isSummaryRow ? {backgroundColor: "skyblue"} : {};
      },
      spanMethod({row, rowIndex, columnIndex}) {
        if (columnIndex === 0 || columnIndex === 1) {
          if (rowIndex > 0 && row.matnr === this.tableData[rowIndex - 1].matnr) {
            return [0, 0];
          }
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.tableData.length; i++) {
            if (row.matnr === this.tableData[i].matnr) {
              rowspan++;
            } else {
              break;
            }
          }
          return [rowspan, 1];
        }
        if (columnIndex === 2) {
          if (rowIndex > 0 && row.matkl === this.tableData[rowIndex - 1].matkl) {
            return [0, 0];
          }
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.tableData.length; i++) {
            if (row.matkl === this.tableData[i].matkl) {
              rowspan++;
            } else {
              break;
            }
          }
          return [rowspan, 1];
        }
        if (columnIndex === 3) {
          if (rowIndex > 0 && row.lgort === this.tableData[rowIndex - 1].lgort) {
            return [0, 0];
          }
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.tableData.length; i++) {
            if (row.lgort === this.tableData[i].lgort) {
              rowspan++;
            } else {
              break;
            }
          }
          return [rowspan, 1];
        }
      },
      handleExport() {
        let list = this.materialNos.split("\n").map(line => line.trim()).filter(item => item.length > 0);
        if (list.length === 0) {
          this.$message.error("请输入物料号");
          return;
        }
        this.exportLoading = true;
        this.$http.exportExcelByHeader("basic", "baseMaterials/stock", list, "post")
          .finally(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>

<style scoped lang="scss">
</style>
